import type { ListBoardCardSelect } from 'app/components/lists/board/boardTypes'
import { RecipeCard } from 'app/components/lists/card/RecipeCard'
import { CASE_CARD } from 'lib/systemCardRecipes'
import { TreatmentCard } from './treatmentFixture'

export function CaseCard({
  card,
  onOpen,
  onDragStart,
  onDragEnd,
  dragging,
  select,
}: {
  card: TreatmentCard
  onOpen: () => void
  onDragStart: () => void
  onDragEnd: () => void
  dragging: boolean
  /** Set while the board is picking cases for a bulk action. */
  select?: ListBoardCardSelect
}) {
  return (
    <RecipeCard
      recipe={CASE_CARD}
      subject={{ kind: `case`, card }}
      drag={{ dragging, onDragStart, onDragEnd, select }}
      onOpen={onOpen}
    />
  )
}
